<template>


<section class="kc-elm kc-css-862243 kc_row kc-pc-loaded">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-991302 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-917637 ">
                  <div class="wr deb derb dea dera none nonea">
                     <h2 class="t1">Our </h2>
                     <h2 class="t2"> certificates &amp; awards</h2>
                     <p class="t4">We won an award in 2013 and nominees every year as a web design agency of the year. High quality. Following deadlines. Experienced team</p>
                  </div>
               </div>
               <div class="ssc_carousel template-1 kc-elm kc-css-576096 kc_tabs group kc-tabs-slider">
                  <div class="owl-carousel owl-theme" style="opacity: 1; display: block;">
                     <div class="owl-wrapper-outer">
                        <div class="owl-wrapper" style="width: 4102px; left: 0px; display: block;">
                           <div class="owl-item" style="width: 293px;">
                              <div id="new-tab9" class="kc-elm kc-css-539309 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class=" type1 mo  none kc-elm kc-css-705359 ssc_img_ef">
                                       <div class="iw"><img data-src="../../assets/images/Frame-116.png" alt="" class="none lazyloaded" src="../../assets/images/Frame-116.png"></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 293px;">
                              <div id="new-tab10" class="kc-elm kc-css-142954 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class=" type1 mo  none kc-elm kc-css-668667 ssc_img_ef">
                                       <div class="iw"><img data-src="../../assets/images/Frame-118.png" alt="" class="none lazyloaded" src="../../assets/images/Frame-118.png"></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 293px;">
                              <div id="new-tab11" class="kc-elm kc-css-665296 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class=" type1 mo  none kc-elm kc-css-100194 ssc_img_ef">
                                       <div class="iw"><img data-src="../../assets/images/Frame-119.png" alt="" class="none lazyloaded" src="../../assets/images/Frame-119.png"></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 293px;">
                              <div id="new-tab12" class="kc-elm kc-css-710443 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class=" type1 mo  none kc-elm kc-css-755711 ssc_img_ef">
                                       <div class="iw"><img data-src="../../assets/images/Frame-121.png" alt="" class="none lazyloaded" src="../../assets/images/Frame-121.png"></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 293px;">
                              <div id="new-tab13" class="kc-elm kc-css-967985 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class=" type1 mo  none kc-elm kc-css-305921 ssc_img_ef">
                                       <div class="iw"><img data-src="../../assets/images/Frame-116.png" alt="" class="none ls-is-cached lazyloaded" src="../../assets/images/Frame-116.png"></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 293px;">
                              <div id="new-tab14" class="kc-elm kc-css-233547 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class=" type1 mo  none kc-elm kc-css-567880 ssc_img_ef">
                                       <div class="iw"><img data-src="../../assets/images/Frame-118.png" alt="" class="none ls-is-cached lazyloaded" src="../../assets/images/Frame-118.png"></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 293px;">
                              <div id="new-tab15" class="kc-elm kc-css-408840 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class=" type1 mo  none kc-elm kc-css-793048 ssc_img_ef">
                                       <div class="iw"><img data-src="../../assets/images/Frame-119.png" alt="" class="none ls-is-cached lazyloaded" src="../../assets/images/Frame-119.png"></div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="owl-controls clickable">
                        <div class="owl-pagination">
                           <div class="owl-page active"><span class=""></span></div>
                           <div class="owl-page"><span class=""></span></div>
                        </div>
                        <div class="owl-buttons">
                           <div class="owl-prev">
                              <div class="svg">
                                 <svg width="30" height="18" viewBox="0 0 30 18" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.22785 0.771973L9.56414 2.10833L3.61767 8.05487H30V9.94478H3.61767L9.56414 15.8913L8.22785 17.2276L-1.90735e-06 8.99976L8.22785 0.771973Z"></path>
                                 </svg>
                              </div>
                              <span class="t"></span>
                           </div>
                           <div class="owl-next">
                              <span class="t"></span>
                              <div class="svg">
                                 <svg width="30" height="18" viewBox="0 0 30 18" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.7721 0.771973L20.4359 2.10833L26.3823 8.05487H0V9.94478H26.3823L20.4359 15.8913L21.7721 17.2276L30 8.99976L21.7721 0.771973Z"></path>
                                 </svg>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "Certificate",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Certificate"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_column{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container{height:100%;}
.kingcomposer div.kc_column{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column{width:100%;}
}
.kc_tabs{margin-bottom:24px;}
.kc_tabs{display:inline-block;width:100%;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
img{border:0;max-width:100%;}
svg:not(:root){overflow:hidden;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
*,*:before,*:after{box-sizing:inherit;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
body .kc_tab_content:after{content:"";display:block;clear:both;}
.owl-theme .owl-controls{margin-top:20px;text-align:center;}
.owl-theme .owl-controls .owl-buttons>div{color:#FFF;display:inline-block;zoom:1;*display:inline;margin:5px;padding:3px 10px;font-size:8px;-webkit-border-radius:30px;-moz-border-radius:30px;border-radius:50px;background:#272727;filter:Alpha(Opacity=50);opacity:.5;}
.owl-theme .owl-controls.clickable .owl-buttons div:hover{filter:Alpha(Opacity=100);opacity:1;text-decoration:none;}
.owl-theme .owl-controls .owl-page{display:inline-block;zoom:1;*display:inline;}
.owl-theme .owl-controls .owl-page span{display:block;width:8px;height:8px;margin:5px 3px;filter:Alpha(Opacity=30);opacity:.3;-webkit-border-radius:20px;-moz-border-radius:20px;border-radius:20px;background:#272727;}
.owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{filter:Alpha(Opacity=100);opacity:1;}
.owl-carousel .owl-wrapper:after{content:".";display:block;clear:both;visibility:hidden;line-height:0;height:0;}
.owl-carousel{display:none;position:relative;width:100%;-ms-touch-action:pan-y;}
.owl-carousel .owl-wrapper{display:none;position:relative;-webkit-transform:translate3d(0,0,0);}
.owl-carousel .owl-wrapper-outer{overflow:hidden;position:relative;width:100%;}
.owl-carousel .owl-item{float:left;}
.owl-controls .owl-page,.owl-controls .owl-buttons div{cursor:pointer;}
.owl-controls{-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);}
.owl-carousel .owl-wrapper,.owl-carousel .owl-item{-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-ms-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);}
body .owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{transform:scale(1.3);}
body .owl-theme .owl-controls .owl-buttons>div{opacity:.8;background-color:#474747;font-weight:700;padding:5px 20px;font-size:14px;text-align:center;}
body .owl-theme .owl-controls .owl-buttons>div:hover{opacity:1;}
.owl-theme .owl-controls .owl-page span{transition:all 0.3s;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
body .ssc_img_ef{position:relative;width:auto;transition:all 300ms ease-in;display:table;}
.ssc_img_ef:hover{z-index:9;}
.ssc_img_ef img{display:inline;transition:all 400ms;margin-bottom:-8px;}
.ssc_img_ef>div{overflow:hidden;display:table-cell;width:100%;height:100%;}
.ssc_img_ef.type1{display:table;}
.ssc_img_ef.type1>div{display:block;}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
body .owl-carousel:after{content:"";clear:both;display:block;}
.ssc_carousel .owl-theme .owl-controls{margin-top:0;}
.ssc_carousel .owl-theme .owl-controls{position:relative;z-index:3;}
.owl-next,.owl-prev{transition:all 200ms;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.owl-item:hover{z-index:5;}
.kc-col-container:after{content:"";display:block;clear:both;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t4{font-size:20px;line-height:26px;padding-top:20px!important;}
body .owl-theme .owl-controls .owl-buttons > div{padding:0;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
body.kc-css-system .kc-css-862243{padding-top:60px;padding-bottom:85px;}
body.kc-css-system .kc-css-991302{padding-right:0px;padding-left:0px;}
body.kc-css-system .kc-css-917637.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-917637{text-align:center;margin-bottom:0px;padding-top:25px;padding-bottom:25px;display:inline-block;}
body.kc-css-system .kc-css-917637 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;margin-top:10px;margin-right:-5px;}
body.kc-css-system .kc-css-917637 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:25px;margin-right:-10px;}
body.kc-css-system .kc-css-917637 .t1{line-height:45px;margin-bottom:0px;display:inline;}
body.kc-css-system .kc-css-917637 .t2{color:#ED7D31;line-height:45px;display:inline;}
body.kc-css-system .kc-css-917637 .t4{margin-top:25px;padding-right:24.5%;padding-left:24.5%;}
body.kc-css-system .kc-css-576096{padding-top:10px;}
body.kc-css-system .kc-css-576096 .owl-page span{background-color:rgba(243, 84, 68, 0.50);width:10px;height:5px;margin-right:5px;margin-left:5px;}
body.kc-css-system .kc-css-576096 .owl-page.active span,body.kc-css-system .kc-css-576096 .owl-page:hover span{background-color:#ED7D31;width:20px;height:5px;}
body.kc-css-system .kc-css-576096 .owl-pagination{margin-top:40px;}
body.kc-css-system .kc-css-576096 .owl-controls .owl-buttons div{color:#999999;background-color:rgba(255, 255, 255, 0);padding-right:0px!important;padding-left:0px!important;margin-right:30px;margin-left:30px;}
body.kc-css-system .kc-css-576096 .owl-controls .owl-buttons div:hover{color:#ED7D31;background-color:rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-576096 .owl-controls .owl-buttons{margin-top:-37px;}
body.kc-css-system .kc-css-576096 .owl-controls .owl-buttons div svg{width:138px;height:18px;}
body.kc-css-system .kc-css-576096 .svg{fill:#999999;}
body.kc-css-system .kc-css-576096 .svg:hover{fill:#ED7D31;}
body.kc-css-system .kc-css-539309{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-705359{width:100%;box-shadow:none;border-radius:10px 10px 10px 10px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-705359 img{width:100%;}
body.kc-css-system .kc-css-142954{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-668667{width:100%;box-shadow:none;border-radius:10px 10px 10px 10px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-668667 img{width:100%;}
body.kc-css-system .kc-css-665296{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-100194{width:100%;box-shadow:none;border-radius:10px 10px 10px 10px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-100194 img{width:100%;}
body.kc-css-system .kc-css-710443{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-755711{width:100%;box-shadow:none;border-radius:10px 10px 10px 10px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-755711 img{width:100%;}
body.kc-css-system .kc-css-967985{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-305921{width:100%;box-shadow:none;border-radius:10px 10px 10px 10px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-305921 img{width:100%;}
body.kc-css-system .kc-css-233547{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-567880{width:100%;box-shadow:none;border-radius:10px 10px 10px 10px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-567880 img{width:100%;}
body.kc-css-system .kc-css-408840{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-793048{width:100%;box-shadow:none;border-radius:10px 10px 10px 10px;-webkit-filter:grayscale(0%);filter:grayscale(0%);}
body.kc-css-system .kc-css-793048 img{width:100%;}
@media only screen and (max-width:667px){
body.kc-css-system .kc-css-917637 .t4{padding-right:15px;padding-left:15px;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-862243{padding-top:40px;padding-bottom:80px;}
body.kc-css-system .kc-css-576096 .owl-controls .owl-buttons{margin-top:0px;}
body.kc-css-system .kc-css-539309{text-align:center;margin-right:auto;margin-left:auto;float:inherit;}
body.kc-css-system .kc-css-705359{text-align:center;}
body.kc-css-system .kc-css-668667{text-align:center;}
body.kc-css-system .kc-css-665296{text-align:center;margin-right:auto;margin-left:auto;float:inherit;}
body.kc-css-system .kc-css-100194{text-align:center;}
body.kc-css-system .kc-css-755711{text-align:center;}
body.kc-css-system .kc-css-967985{text-align:center;margin-right:auto;margin-left:auto;float:inherit;}
body.kc-css-system .kc-css-305921{text-align:center;}
body.kc-css-system .kc-css-567880{text-align:center;}
body.kc-css-system .kc-css-408840{text-align:center;margin-right:auto;margin-left:auto;float:inherit;}
body.kc-css-system .kc-css-793048{text-align:center;}
}
</style>



// WEBPACK FOOTER //
// src/components/Blocks/Certificate.vue